function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 2H37V46H2V2Z",
  stroke: "black",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2542 38V36.7661C26.3077 36.5017 28 34.9153 28 32.3301C28 30.1267 26.7676 28.7656 24.3487 28.2661L23.2542 28.0507V25.0052C24.0452 25.1423 24.6246 25.818 24.6522 26.5916H27.7425C27.7149 24.2609 25.9858 22.6158 23.2542 22.3416V21H21.9298V22.3318C18.959 22.5668 17.2483 24.1532 17.2483 26.6895C17.2483 28.8341 18.4808 30.2442 20.8353 30.7926L21.9298 31.0472V34.2005C20.9457 34.0927 20.2375 33.4171 20.1915 32.5553H17C17.0092 35.0622 18.8211 36.6192 21.9298 36.7857V38H23.2542ZM24.8545 32.7316C24.8545 33.5639 24.2567 34.1221 23.2542 34.2005V31.2823C24.3303 31.4977 24.8545 31.9775 24.8545 32.7316ZM20.4766 26.3566C20.4766 25.6025 21.0744 25.0444 21.9298 24.9856V27.7667C20.9824 27.5611 20.4766 27.0714 20.4766 26.3566Z",
  fill: "#FD665E"
});

var SvgIcon2 = function SvgIcon2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon2.f03cc725.svg";
export { ForwardRef as ReactComponent };